type LovableErrorOptions = {
  mechanism?: "manual" | "onerror" | "unhandledrejection" | "react_error_boundary";
  handled?: boolean;
  severity?: "error" | "warning" | "info";
};

type LovableEvents = {
  captureException?: (
    error: unknown,
    context?: Record<string, unknown>,
    options?: LovableErrorOptions,
  ) => void;
};

declare global {
  interface Window {
    __lovableEvents?: LovableEvents;
  }
}

export function reportLovableError(error: unknown, context: Record<string, unknown> = {}) {
  if (typeof window === "undefined") return;
  const enriched = {
    source: "react_error_boundary",
    route: window.location.pathname,
    ...context,
  };
  window.__lovableEvents?.captureException?.(error, enriched, {
    mechanism: "react_error_boundary",
    handled: false,
    severity: "error",
  });
  // Forward to Sentry as well so it appears in the dashboard with extra
  // context (componentStack, route). Sentry's own global handlers will
  // capture the raw throw; this call attaches the React boundary metadata.
  void import("@sentry/react")
    .then((Sentry) => {
      Sentry.captureException(error, { extra: enriched });
    })
    .catch(() => {
      // Sentry not initialized (e.g. DSN endpoint failed) — ignore.
    });
}
